import * as ProductHistory from '../../../services/productHistory.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import t from './ProductHistory.type';

export const fetchProductHIstoryList = (params) => async (dispatch) => {
  try {
    const res = await ProductHistory.fetchProductHistoryListService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_HISTORY_LIST,
        payload: res.data,
      });
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
